import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import config from "../config.json";
import axios from "axios";
import parse from "html-react-parser";

export const ServerNews = () => {
  const apiEndPoint = config.apiEndPoint + "info/server-news";
  const [news, setNews] = useState(null);

  useEffect(() => {
    axios
      .get(apiEndPoint)
      .then((response) => response.data)
      .then((data) => {
        setNews(data);
      });
  }, []);

  return (
    <Box sx={{ backgroundColor: "#121212", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="md">
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ color: "#fff", fontWeight: "bold", mb: 4 }}
        >
          Server News & Updates
        </Typography>

        <Divider sx={{ bgcolor: "#555", height: 3, mb: 4, width: "50%", mx: "auto" }} />

        {!news ? (
          <Box textAlign="center">
            <CircularProgress sx={{ color: "#ccc" }} />
            <Typography sx={{ color: "#aaa", mt: 2 }}>Loading updates...</Typography>
          </Box>
        ) : news.length === 0 ? (
          <Typography sx={{ color: "#aaa", textAlign: "center" }}>No updates available.</Typography>
        ) : (
          <FadeIn>
            {news.map((e, idx) => (
              <Card
                key={idx}
                sx={{
                  backgroundColor: "#1e1e1e",
                  color: "#ddd",
                  mb: 4,
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ color: "#00bcd4", fontWeight: "bold" }}>
                    {e.title}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#888", mb: 2, display: "block" }}>
                    {new Date(e.date).toLocaleString()}
                  </Typography>
                  <Divider sx={{ bgcolor: "#333", my: 2 }} />
                  <Box>{parse(e.content)}</Box>
                </CardContent>
              </Card>
            ))}
          </FadeIn>
        )}
      </Container>
    </Box>
  );
};
